import { render, staticRenderFns } from "./configManager.vue?vue&type=template&id=c2b7454e"
import script from "./configManager.vue?vue&type=script&lang=js"
export * from "./configManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports